import React from 'react';
import './expireModal.scss';
import { Modal } from 'react-bootstrap';

const ExpireModal = (props) => {
    return (
        <div>
            {/* ############## Expire Alert Modal ############### */}
            <Modal
                show={props.expireAlert}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={props.handleCloseModal}
                dialogClassName={"expire-modal"}
            >
                <div className="disable-post-content1">
                    <h3 className="py-3">{props.expireMessage}</h3>
                    <button className="primaryButton" onClick={() => props.closeSubModal()}>{localStorage.getItem('role')?.includes('admin') ? (props.type === 'other' ? 'OK' : "Upgrade now") : 'Ok'}</button>
                </div>
            </Modal>
        </div>
    )
}

export default ExpireModal;
